/**
 * Shared phone-number validation for Indian mobile numbers.
 *
 * Rules:
 *   - Strip a leading "+91", "91" (if 12-digit total), or "0" (if 11-digit total)
 *   - Remaining string must be exactly 10 digits
 *   - Must start with 6, 7, 8, or 9
 *   - Stored / submitted WITHOUT the country-code prefix
 */

/**
 * Strip optional country-code prefix and non-digit characters,
 * returning a raw digit string (may be any length).
 */
export function sanitizePhone(raw) {
  let p = (raw || "").trim().replace(/\s+/g, "");
  if (p.startsWith("+91")) p = p.slice(3);
  else if (p.startsWith("91") && p.length === 12) p = p.slice(2);
  else if (p.startsWith("0") && p.length === 11) p = p.slice(1);
  return p.replace(/\D/g, ""); // drop any remaining non-digits (dashes, spaces, etc.)
}

/**
 * Validate an Indian mobile number.
 * Returns a human-readable error string, or null when valid.
 */
export function validatePhone(raw) {
  const p = sanitizePhone(raw);
  if (p.length === 0) return "Phone number is required.";
  if (p.length !== 10) return "Phone number must be exactly 10 digits.";
  if (!/^[6-9]/.test(p)) return "Phone number must start with 6, 7, 8, or 9.";
  return null; // null → valid
}

/** Returns true when the phone string passes all validation rules. */
export function isValidPhone(raw) {
  return validatePhone(raw) === null;
}
